import { Assets, type Texture } from 'pixi.js';

/**
 * Generated key-art textures (Higgsfield). Preloaded once at startup so scenes
 * can use them synchronously; everything degrades gracefully to the existing
 * vector look if a texture fails to load.
 */
const SOURCES = {
  keyart: '/art/keyart.jpg', // title / menu backdrop
  hero_portrait: '/art/hero_portrait.jpg', // menu card bust
  floor: '/art/floor.jpg', // tiling dungeon-floor texture
  hero_idle: '/art/hero_idle.png',
  // video-derived directional animation frames
  walk_d0: '/art/walk_d0.png',
  walk_d1: '/art/walk_d1.png',
  walk_d2: '/art/walk_d2.png',
  walk_d3: '/art/walk_d3.png',
  walk_d4: '/art/walk_d4.png',
  walk_d5: '/art/walk_d5.png',
  walk_s0: '/art/walk_s0.png',
  walk_s1: '/art/walk_s1.png',
  walk_s2: '/art/walk_s2.png',
  walk_s3: '/art/walk_s3.png',
  walk_s4: '/art/walk_s4.png',
  walk_s5: '/art/walk_s5.png',
  atk0: '/art/atk0.png',
  atk1: '/art/atk1.png',
  atk2: '/art/atk2.png',
  atk3: '/art/atk3.png',
  atk4: '/art/atk4.png',
  bolt: '/art/bolt.png',
  freeze: '/art/freeze.png',
  // dungeon decor props
  prop_torch: '/art/prop_torch.png',
  prop_chest: '/art/prop_chest.png',
  prop_crystals: '/art/prop_crystals.png',
  prop_bones: '/art/prop_bones.png',
  prop_barrel: '/art/prop_barrel.png',
  wall_tex: '/art/wall_tex.jpg',
} as const;

type ArtKey = keyof typeof SOURCES;

/**
 * Bump this whenever a texture file is changed in place (the filenames are
 * stable, so without a version query Telegram's webview / browsers can serve a
 * stale image forever). The query string forces a fresh fetch on every bump.
 */
const ART_VERSION = '3';

const cache = new Map<ArtKey, Texture>();

/** Load all art. Safe to await; never throws (missing art just stays absent). */
export async function loadArt(): Promise<void> {
  await Promise.all(
    (Object.keys(SOURCES) as ArtKey[]).map(async (k) => {
      try {
        cache.set(k, await Assets.load(`${SOURCES[k]}?v=${ART_VERSION}`));
      } catch {
        /* keep the vector fallback */
      }
    }),
  );
}

export function art(key: ArtKey): Texture | null {
  return cache.get(key) ?? null;
}
